import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "axios";
import Select from "react-select";

import "../../../styles/Form.css";
import { MODE } from "../../../constants/SiteConstants";
import Switch from "../../../components/commonComponent/Switch";
const API_URL = process.env.REACT_APP_API_URL;

const AttributeForm = ({
  fields,
  onSubmit,
  mode,
  dynamicAttributeFields,
  initialData = {},
  handleImageChange,
  imagePreview,
  onFieldChange,
}) => {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [categoryOptions, setCategoryOptions] = useState({});
  const [dropdownFields, setDropdownFields] = useState([]);

  useEffect(() => {
    if (initialData && mode === MODE.UPDATE) {
      setFormData(initialData);
      setDropdownFields(initialData.options || []);
    }
  }, [initialData, mode]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));

    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: undefined,
      }));
    }

    if (onFieldChange) {
      onFieldChange(name, type === "checkbox" ? checked : value);
    }
  };
  const handleDynamicFieldChange = (name, value) => {
    onFieldChange(name, value);
  };

  const validateForm = () => {
    const formErrors = {};

    fields.forEach((field) => {
      const fieldValue = formData[field.name];

      if (field.required && !fieldValue) {
        formErrors[field.name] = `${field.label} is required`;
      }
    });

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleStatusChange = (name, newStatus) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: newStatus,
    }));
  };

  useEffect(() => {
    if (formData.type === MODE.DROPDOWN && dropdownFields.length === 0) {
      setDropdownFields([""]);
    }
  }, [formData.type, dropdownFields.length]);

  const handleDropdownFieldChange = (index, value) => {
    const newDropdownFields = [...dropdownFields];
    newDropdownFields[index] = value;
    setDropdownFields(newDropdownFields);
  };

  const addDropdownField = () => {
    setDropdownFields([...dropdownFields, ""]);
  };

  const removeDropdownField = (index) => {
    const newDropdownFields = dropdownFields.filter((_, i) => i !== index);
    setDropdownFields(newDropdownFields);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrors({});
    if (validateForm()) {
      const finalFormData = {
        ...formData,
        options: dropdownFields,
      };
      const finalData =
        formData.type === MODE.DROPDOWN ? finalFormData : formData;
      onSubmit(finalData);
    }
  };
  // Fetch category options based on field name
  const fetchCategoryOptions = async (fieldName) => {
    try {
      let response;
      if (fieldName === "blogcategory") {
        response = await axios.get(
          `${API_URL}/blogcategory/getAllblogcategory`
        );
      } else if (fieldName === "category") {
        response = await axios.get(
          `${API_URL}/productcategory/getAllproductcategories`
        );
      }
      if (response?.data?.data) {
        const options = response.data.data.map((category) => ({
          value: category._id,
          label: category.name,
        }));

        setCategoryOptions((prevOptions) => ({
          ...prevOptions,
          [fieldName]: options,
        }));
      }
    } catch (error) {}
  };
  const handleTagsChange = (selectedOptions, fieldName) => {
    const tags = selectedOptions.map((option) => option.value);
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: tags,
    }));

    if (onFieldChange) {
      onFieldChange(fieldName, tags);
    }
  };

  useEffect(() => {
    fields.forEach((field) => {
      if (field.isMultifield) {
        fetchCategoryOptions(field.name);
      } else if (field.isTagsMultifield) {
        // fetchServiceOptions();
      }
    });
  }, [fields]);

  return (
    <form onSubmit={handleSubmit}>
      {fields.map((field) => (
        <div className="mb-4" key={field.name}>
          <label
            htmlFor={field.name}
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            {field.label}
          </label>

          {field.type === "file" ? (
            <>
              <input
                type="file"
                className="w-full rounded-md border border-stroke p-3 outline-none file:mr-4 file:rounded file:border-[0.5px] file:border-stroke file:bg-[#EEEEEE] file:py-1 file:px-2.5 file:text-sm"
                id={field.name}
                name={field.name}
                onChange={handleImageChange}
                multiple
              />
              {imagePreview && imagePreview.length > 0 && (
                <div className="mt-2 flex gap-2">
                  {imagePreview.map((preview, index) => (
                    <img
                      key={index}
                      src={preview}
                      alt="Preview"
                      className="w-1/3 h-auto rounded-lg"
                    />
                  ))}
                </div>
              )}
            </>
          ) : field.type === "rich-text" ? (
            <ReactQuill
              value={formData[field.name] || ""}
              onChange={(value) =>
                handleChange({ target: { name: field.name, value } })
              }
              placeholder={field.placeholder}
              className="mt-2"
            />
          ) : field.type === "select" ? (
            <select
              className="block w-full border border-gray-300 rounded-lg py-2 px-3 
              text-gray-700 focus:border-blue-500 focus:ring-blue-500 focus:outline-none"
              id={field.name}
              name={field.name}
              value={formData[field.name] || ""}
              onChange={handleChange}
            >
              <option value="" disabled>
                {field.placeholder}
              </option>
              {field.options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.name}
                </option>
              ))}
            </select>
          ) : field.type === "radio" ? (
            <div>
              {field.options.map((option) => (
                <label key={option.value} style={{ marginRight: "10px" }}>
                  <input
                    type="radio"
                    name={field.name}
                    value={option.value}
                    checked={formData[field.name] === option.value}
                    onChange={handleChange}
                  />
                  {option.name}
                </label>
              ))}
            </div>
          ) : field.type === "checkbox" ? (
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id={field.name}
                name={field.name}
                checked={formData[field.name] || false}
                onChange={handleChange}
              />
              <label htmlFor={field.name} className="form-check-label">
                {field.options[0].name}
              </label>
            </div>
          ) : field.type === "switch" ? (
            <div className="mt-7">
              <Switch
                isActive={formData[field.name] || false}
                itemId={field.name}
                onStatusChange={handleStatusChange}
              />
            </div>
          ) : field.isMultifield ? (
            <Select
              isMulti
              options={categoryOptions[field.name] || []}
              onChange={(selectedOptions) =>
                handleTagsChange(selectedOptions, field.name)
              }
              placeholder={field.placeholder}
              className="mt-2"
            />
          ) : (
            <input
              type={field.type || "text"}
              className="block w-full border border-gray-300 rounded-lg py-2 px-3 
              text-gray-700 focus:border-blue-500 focus:ring-blue-500 focus:outline-none"
              id={field.name}
              name={field.name}
              placeholder={field.placeholder}
              value={formData[field.name] || ""}
              onChange={handleChange}
            />
          )}

          {errors[field.name] && (
            <p className="text-red-500 text-sm mt-1">{errors[field.name]}</p>
          )}
        </div>
      ))}

      {formData.type === MODE.DROPDOWN && (
        <div className="dropdown-fields-section mt-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Add Dropdown Options
          </label>
          {dropdownFields.map((value, index) => (
            <div key={index} className="flex items-center mb-2">
              <input
                type="text"
                value={value}
                onChange={(e) =>
                  handleDropdownFieldChange(index, e.target.value)
                }
                className="block w-full text-[#444] border border-gray-300 rounded-lg py-2 px-3 mr-2"
                placeholder={`Option ${index + 1}`}
              />
              {dropdownFields.length > 1 && (
                <button
                  type="button"
                  className="text-red-500"
                  onClick={() => removeDropdownField(index)}
                >
                  <svg
                    className="fill-current"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.7535 2.47502H11.5879V1.9969C11.5879 1.15315 10.9129 0.478149 10.0691 0.478149H7.90352C7.05977 0.478149 6.38477 1.15315 6.38477 1.9969V2.47502H4.21914C3.40352 2.47502 2.72852 3.15002 2.72852 3.96565V4.8094C2.72852 5.42815 3.09414 5.9344 3.62852 6.1594L4.07852 15.4688C4.13477 16.6219 5.09102 17.5219 6.24414 17.5219H11.7004C12.8535 17.5219 13.8098 16.6219 13.866 15.4688L14.3441 6.13127C14.8785 5.90627 15.2441 5.3719 15.2441 4.78127V3.93752C15.2441 3.15002 14.5691 2.47502 13.7535 2.47502ZM7.67852 1.9969C7.67852 1.85627 7.79102 1.74377 7.93164 1.74377H10.0973C10.2379 1.74377 10.3504 1.85627 10.3504 1.9969V2.47502H7.70664V1.9969H7.67852ZM4.02227 3.96565C4.02227 3.85315 4.10664 3.74065 4.24727 3.74065H13.7535C13.866 3.74065 13.9785 3.82502 13.9785 3.96565V4.8094C13.9785 4.9219 13.8941 5.0344 13.7535 5.0344H4.24727C4.13477 5.0344 4.02227 4.95002 4.02227 4.8094V3.96565ZM11.7285 16.2563H6.27227C5.79414 16.2563 5.40039 15.8906 5.37227 15.3844L4.95039 6.2719H13.0785L12.6566 15.3844C12.6004 15.8625 12.2066 16.2563 11.7285 16.2563Z"
                      fill=""
                    />
                    <path
                      d="M9.00039 9.11255C8.66289 9.11255 8.35352 9.3938 8.35352 9.75942V13.3313C8.35352 13.6688 8.63477 13.9782 9.00039 13.9782C9.33789 13.9782 9.64727 13.6969 9.64727 13.3313V9.75942C9.64727 9.3938 9.33789 9.11255 9.00039 9.11255Z"
                      fill=""
                    />
                    <path
                      d="M11.2502 9.67504C10.8846 9.64692 10.6033 9.90004 10.5752 10.2657L10.4064 12.7407C10.3783 13.0782 10.6314 13.3875 10.9971 13.4157C11.0252 13.4157 11.0252 13.4157 11.0533 13.4157C11.3908 13.4157 11.6721 13.1625 11.6721 12.825L11.8408 10.35C11.8408 9.98442 11.5877 9.70317 11.2502 9.67504Z"
                      fill=""
                    />
                    <path
                      d="M6.72245 9.67504C6.38495 9.70317 6.1037 10.0125 6.13182 10.35L6.3287 12.825C6.35683 13.1625 6.63808 13.4157 6.94745 13.4157C6.97558 13.4157 6.97558 13.4157 7.0037 13.4157C7.3412 13.3875 7.62245 13.0782 7.59433 12.7407L7.39745 10.2657C7.39745 9.90004 7.08808 9.64692 6.72245 9.67504Z"
                      fill=""
                    />
                  </svg>
                </button>
              )}
            </div>
          ))}
          <button
            type="button"
            onClick={addDropdownField}
            className="mt-4 rounded-lg px-3 bg-[#1C2434] text-white py-3 hover:bg-[#1C2434]"
          >
            Add Option
          </button>
        </div>
      )}

      <button
        type="submit"
        className="mt-4 w-full rounded-lg bg-[#1C2434] text-white py-3 hover:bg-[#1C2434]"
      >
        {mode === MODE.ADD ? "Add" : "Update"} Data
      </button>
    </form>
  );
};

export default AttributeForm;
